import axios from 'axios';

export default class VotingApi {
    static getBaseUrl() {
        return "https://dun.vydeo.xyz/iter3/voting";
         //return "http://localhost:5003/voting";
    }

    static vote( newsId, indexId, decision, token) {
        return axios.post(VotingApi.getBaseUrl() + '/vote?turnstile_token=' + token, {
            news_id: newsId,
            index_id: indexId,
            decision: decision
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
    }

    static getNews(previousNewsId, token) {

        return axios.get(VotingApi.getBaseUrl() + '/get', {
            params: {
                captcha: token,
                previous_news_id: previousNewsId
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
    }

    static getHottest(token) {
            return axios.get(VotingApi.getBaseUrl() + '/get_hottest', {
                params: {
                    captcha: token,
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
    }
}